import {CommonModule} from '@angular/common';
import {ChangeDetectionStrategy, Component, Input, inject} from '@angular/core';
import {FilterSetPreviewPercentageStore} from '@em/data-feed/data-access-products';
import {ProductGroupFilterDto} from '@em/data-feed/util-types';
import {EmBoxModule} from '@em/shared/ui';
import {EmPieChartModule} from '@em/shared/ui-charts';
import {isNotNullOrUndefined} from '@em/shared/util-rxjs';
import {CountryCode} from '@em/shared/util-types';
import {map} from 'rxjs';

@Component({
  selector: 'em-filter-set-preview',
  imports: [CommonModule, EmPieChartModule, EmBoxModule],
  templateUrl: './filter-set-preview.component.html',
  styleUrls: ['./filter-set-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [FilterSetPreviewPercentageStore],
})
export class EmFilterSetPreviewComponent {
  @Input({required: true}) title?: string;
  @Input({required: true}) set percentageOf(
    value: number | ProductGroupFilterDto[] | null,
  ) {
    if (value !== null) {
      if (typeof value === 'number') {
        this._previewPercentageStore.updatePercentageOf(value);
      } else {
        this._previewPercentageStore.updatePercentageOf({
          selected_filters: value,
          manually_added_products: [],
          manually_removed_products: [],
          links: [],
        });
      }
    }
  }
  @Input({required: true}) set filters(value: ProductGroupFilterDto[] | null) {
    if (value) {
      this._previewPercentageStore.updateFilters({
        selected_filters: value,
        manually_added_products: [],
        manually_removed_products: [],
        links: [],
      });
    }
  }
  @Input({required: true}) set country(value: CountryCode | null) {
    if (value) {
      this._previewPercentageStore.updateCountry(value);
    }
  }

  private readonly _previewPercentageStore = inject(
    FilterSetPreviewPercentageStore,
  );

  readonly percentage$ = this._previewPercentageStore.percentage$.pipe(
    isNotNullOrUndefined(),
    map((v) => v * 100),
  );
  readonly isLoading$ = this._previewPercentageStore.isLoading$;
}
